<template>
  <data-table 
    v-model="page" 
    :headers="headers" 
    :loading="dataLoading" 
    :items="items"
    @refresh="load"
    class="elevation-1">
    <template v-slot:[`item.role`]="{ item }">
      <div style="text-transform:lowercase">{{ item.role }}</div>
    </template>
    <template v-slot:[`item.status`]="{ item }">
      <v-icon small class="mr-2" v-if="item.status == 'ok'">
        mdi-check-bold
      </v-icon>
      <div v-if="item.status != 'ok'">{{ item.status }}</div>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon small color="red" @click="deleteItem(item)"> mdi-delete </v-icon>
    </template>
    <template v-slot:no-data> </template>
  </data-table>
</template>

<script>
import Strings from './Strings.js'
const Iam = require('iam')

export default {
  data: () => ({
    page: 1,
    dialog: false,
    dataLoading: true,
    headers: [
      { text: "Organization", align: "start", sortable: false, value: "user" },
      {text: "Member of", value: "member_of"},
      { text: "Role", value: "role", sortable: true },
      { text: "Status", value: "status", sortable: true },
      { text: "Actions", value: "actions", sortable: false },
    ],
    items: [],
    data: null,
  }),
  computed: {
    organization: function () { return this.$route.params.organization },
    ownerCount: function () {
      return this.data.owners.length + this.data.orgowners.length
    }
  },
  created: function () {
    this.load()
  },
  methods: {
    load: function () {
      this.$api.userIsMember(this.username, this.organization, this.callBack(
        response => { this.userIsOwner = response.isOwner },
        error => {
          if (error.status != 403) {
            this.alert("error", "something_went_wrong")
          }
        }))
      this.$api.getOrganization(this.organization, this.callBack(
        response => {
          const allItems = []
          const flatten = (list, role) => {
            list.forEach(element => {
              allItems.push({user: element, role: role, member_of: this.organization, status: "ok"})
            })
          }
          flatten(response.orgmembers, "member")
          flatten(response.orgowners, "owner")
          this.items = allItems
          this.$api.getInvitations(this.organization, {}, this.callBack(
            response => {
              response.forEach(item => {
                if(item.isorganization) {
                  this.items.push({user: item.user, role: item.role, member_of: this.organization, status: item.status})
                }
              })
            },
            error => {
              if (error.status != 403) {
                this.alert("error", "something_went_wrong")
              }
            }, ()=> {
              this.dataLoading = false
            }
          ))
          this.$api.getSubOrgsMembers(this.organization, {}, this.callBack(
            response => {
              response.forEach(item => {
                this.items.push({user: item["organization-id"], role: item.role, member_of: item.suborganization, status: "ok"})
              })
            },
            error => {
              this.alert("error", error.message)
            }
          ))
        }))
    },
    editItem(item) {
      this.alert(
        "confirm", 
        Strings({ user: item.user, organization: this.organization }, "confirm_make_owner"),
        undefined,
        () => {
          const body = new Iam.UpdateOrganizationOrgMemberShip()
          body.org = item.user
          body.role = item.role
          this.$api.updateOrganizationOrgMemberShip(body, this.organization, this.callBack(this.load))
        })
    },

    deleteItem(item) {
      if (item.status == "ok"){
        this.alert(
          "confirm", 
          Strings({ user: item.user, organization: this.organization }, "confirm_removing_organization_from_organization"), 
          undefined, 
          () => {
            if (item.role == "owner")
              this.$api.deleteOrgOwner(item.user, this.organization, this.callBack(this.load))
            else
              this.$api.deleteOrgMember(item.user, this.organization, this.callBack(this.load))
          })
      } else if (item.status == "pending") {
        this.alert(
          "confirm", 
          Strings({ user: item.user, organization: this.organization }, "confirm_removing_organization_invitationn"), 
          undefined,
          () => { this.$api.removePendingOrg2OrgInvitation(this.organization, item.user, this.callBack(this.load)) }
        )
      }
    }
  },
}
</script>

<style scoped>
.v-data-table {
  width: fit-content;
  max-width: 100%;
}
</style>
